import { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'
import { getCurrentInstance } from 'vue'
import { FeatureIdEnum } from '../../enums/feature-id.enum'
import { ROUTER_CONSTS } from '../../router/router.consts'
import { useTagging } from '../use-tagging'

export function useExplainProductAnalysisAction(): {
  tagExplainProductAnalysis: () => void
  navigateToExplainSearch: () => void
} {
  const ctx = getCurrentInstance()
  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }
  const {
    proxy: { $router },
  } = ctx

  const { taggingAction } = useTagging()

  function tagExplainProductAnalysis(): void {
    taggingAction({
      featureId: FeatureIdEnum.EXPLAIN,
      type: EngagementActionsTypeEnum.SEARCH,
    })
  }

  function navigateToExplainSearch(): void {
    $router.push({
      name: ROUTER_CONSTS.routes[FeatureIdEnum.EXPLAIN].search,
    })
  }

  return { tagExplainProductAnalysis, navigateToExplainSearch }
}
